import { render, staticRenderFns } from "./websiteSetting.vue?vue&type=template&id=c83748d8&"
import script from "./websiteSetting.vue?vue&type=script&lang=js&"
export * from "./websiteSetting.vue?vue&type=script&lang=js&"
import style0 from "./websiteSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports